import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "minRows", "maxRows", "inputRef", "size", "value", "width", "invalid", "hasCounter"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { clsx } from 'clsx';
import { useInputSize } from '../../../internal/hooks';
import { TextareaAutosize } from '../../internal/components';
import { calcValueLength, getFormattedCounterText } from '../../internal/utils';
import { getStyles } from './styles';

/**
 * Компонент textarea.
 * Автоматически подстраивает свою высоту под количество введеного текста.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Textarea = /*#__PURE__*/React.forwardRef(function Textarea(props, ref) {
  var onChange = props.onChange,
    minRows = props.minRows,
    maxRows = props.maxRows,
    inputRefProp = props.inputRef,
    sizeProp = props.size,
    value = props.value,
    width = props.width,
    invalid = props.invalid,
    hasCounter = props.hasCounter,
    rest = _objectWithoutProperties(props, _excluded);
  var maxLength = props.maxLength;
  var handleRef = useForkRef(ref, inputRefProp);
  var size = useInputSize(sizeProp);
  var styles = getStyles(size);
  var _React$useState = React.useState(calcValueLength(value)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    length = _React$useState2[0],
    setLength = _React$useState2[1];
  React.useEffect(function () {
    // отдельный useEffect нужен для контроля значения длины при программном изменении value
    // т.к. без пользовательского взаимодействия с компонентом handleChange не вызывается
    setLength(calcValueLength(value));
  }, [value]);
  var handleChange = function handleChange(e) {
    if (onChange) {
      onChange(e, e.currentTarget.value);
    }
    setLength(e.currentTarget.value.length);
  };
  var textareaAutosize = /*#__PURE__*/_jsx(TextareaAutosize, _objectSpread(_objectSpread({}, rest), {}, {
    ref: handleRef,
    value: value,
    className: clsx(styles['textarea'], invalid && styles['invalid'], hasCounter && styles['withCounter']),
    onChange: handleChange,
    minRows: minRows,
    maxRows: maxRows,
    style: {
      width: width
    }
  }));
  return hasCounter ? /*#__PURE__*/_jsxs("div", {
    className: styles['counterWrapper'],
    children: [textareaAutosize, /*#__PURE__*/_jsx("div", {
      className: styles['counter'],
      children: getFormattedCounterText(length, maxLength)
    })]
  }) : textareaAutosize;
});